import DeleteCircle from "./DeleteCircle";
import PanelPreview from "./PanelPreview";
import EditableContent from "./EditableContent";
import PublicationPanelOrderText from "./PublicationPanelOrderText";
import { useStore } from 'react-redux';
import G from './Getters';

export default function PublicationPanel({figurePanelId,number,onEvent,editorState,
  getNameChangeConflict,
}){

  const store = useStore();
  const state = store.getState();
  let figurePanel = G.getFigurePanel(state,figurePanelId);

  let title;
  let { description } = figurePanel;


  let isEditing = editorState.panelIdBeingEdited === figurePanelId;


  const previewWidth = 400;
  return (
    <div class="round-corners hoverable-parent small-padding rel" style={{
      //border:'1px solid #ccc',
      //background:'#eee',
      marginBottom:20,
      marginRight:20,
    }}>
      <div>
        <PublicationPanelOrderText {...{
          getNameChangeConflict,
          figurePanelId,
          onEvent,
          number,
          editorState,
          editing:(isEditing && editorState.panelFieldBeingEdited==="numbering")
        }}/>
      </div>



      <div style={{
        //background:'#ccc',

      }} class="sg-row">

        <div class="sg-row h-center v-center" style={{
          //border:'1px solid #ccc', 
          width:previewWidth,
          //height:previewWidth
        }}>
          <div class="rel" style={{
            width:previewWidth,
            //maxHeight:previewWidth
          }}>
          <PanelPreview {...{
            figurePanelId, 
            maxDimensions:[previewWidth]
          }}/>
          </div>
        </div>
        {false && <div class="small-padding">
          <div>Description</div>
          <EditableContent {...{
            style:{
              //border:'1px solid #ccc',
            },

            onChange:(description) => {
              onEvent && onEvent({
                type:"setProperty",
                figurePanelId,
                description
              })
            },

            type:"textarea",
            value:description

          }}/></div>}
      </div>
      <div 
        class="visible-on-parent-hover" style={{
      position:'absolute',
      top:0,
      right:0,
      width:30,
      height:30,
    }}>
        <DeleteCircle onClick={() => {
          onEvent({
            type:"removeItem",
            item:{ type:"figurePanelId", _id:figurePanelId }
          })
        }} dim={30} theme={"dark"}/>
    </div>
    </div>
    
  )
}
